<template>
  <div class="card-info">
    <div class="row">
      <div class="col-12 col-md-8 col-lg-10 col-xl-10 mx-auto mt-5">
        <card>
          <br />
          <fg-input
            type="email"
            label="Email"
            v-model="email"
            placeholder="Введите Email"
          ></fg-input>
          <fg-input
            type="password"
            label="Пароль"
            v-model="password"
            placeholder="Введите пароль"
          ></fg-input>
          <br />
          <p-button
            class="w-100 mb-3"
            type="warning"
            round
            @click.native.prevent="login"
            >Войти в систему</p-button
          >
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { errorNotify } from "../plugins/functions";

export default {
  name: "login",
  components: {},
  mounted() {},
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    login(loading = true) {
      this.$loading(true);
      this.$http
        .post("admin/login", {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          response.data;
          this.$http.defaults.headers.common["Authorization"] =
            response.data.bearer;
          localStorage.setItem("token", response.data.bearer);
          this.$store.dispatch("setUser", response.data);
        })
        .catch((error) => {
          errorNotify(error, this);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style>
</style>
